<template>
  <v-app>
    <v-app-bar app>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>HMIS</v-toolbar-title>
      <v-toolbar-items>
        <v-btn text>
          <inertia-link :href="route('dashboard')">Dashboard</inertia-link>
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-btn text>
          <!-- <inertia-link :href="route('clients/create')">Clients</inertia-link> -->
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>Title</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app>
      <v-list-item>
        <v-list-item-avatar>
          <v-icon>user</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>John Leider</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>user</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>User</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <slot></slot>
    </v-main>
  </v-app>
</template>
<script>
  export default {
    name: 'app-layout',
    data () {
      return {
        drawer: false,
      }
    },
  }
</script>
